import { createContext, useContext } from "react";

/**
 * O que a tabela da EAP precisa entregar a CADA linha, em qualquer profundidade
 * (unidade → célula → etapa → subetapa → serviço). Passar por prop atravessaria cinco
 * componentes de accordion só para chegar na linha; o contexto local mantém os
 * accordions iguais aos da Projeção Financeira — só montam o nível seguinte.
 */
export const EapTableContext = createContext({
  readOnly: true,
  rulesByNodeKey: {},
  onEditRule: null,
  // O recorte por meses selecionados no gráfico (`Set<"AAAA-MM">`, vazio = EAP completa) e a
  // gravação do ajuste a partir dele: `onSliceAdjust(wbsCodeId, lines, toCompetence,
  // description)` devolve `{ ok, message? }`.
  selectedMonths: new Set(),
  onSliceAdjust: null,
  // Como a linha sem regra própria se rotula quando a origem já traz distribuição no tempo
  // ("Segue o desembolso do ERP"). Sem ele (origem desconhecida), o rótulo antigo.
  followsLabel: null,
  // O nome da origem, que o ajuste mês a mês sobre a referência nomeia (D21).
  originName: null,
  // D20: os nós com ajuste mês a mês ativo (`Map<wbsCodeId, { monthCount, movedCents }>`) e
  // `onEditMonths(target)`, que abre o editor do nó direto no modo mês a mês.
  adjustmentsByNode: null,
  onEditMonths: null,
  // Change 00: a origem da obra (`origin.id`) e o nome dela ("Previsto (Prevision)") — a marca
  // "sem cronograma" diz em que origem falta o cronograma e o que corrigir lá —, e o código
  // de cada linha já desenhada (`Map<wbsCodeId, wbs>`), que a regra herdada usa para nomear
  // o ancestral.
  originId: null,
  originLabel: null,
  wbsLabels: null,
});

export const useEapTable = () => useContext(EapTableContext);
